module.exports = __webpack_public_path__ + "img/member.01c5f447.png";